import { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

/**
 * Always loads Vughy public countries via our API proxy (no client cache):
 * GET /api/countries → https://api.vughy.com/api/public/countries (VUGHY_VISA_API_KEY)
 */
export const loadCountries = async () => {
  const res = await axios.get(`${API_URL}/countries`, {
    params: { _t: Date.now() },
    headers: { 'Cache-Control': 'no-cache' },
  });
  return Array.isArray(res.data) ? res.data : [];
};

export const useCountries = ({ enabled = true } = {}) => {
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(Boolean(enabled));
  const [error, setError] = useState('');

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return undefined;
    }

    let cancelled = false;

    const run = async () => {
      setLoading(true);
      setError('');
      try {
        const list = await loadCountries();
        if (!cancelled) setCountries(list);
      } catch (err) {
        if (!cancelled) {
          setError(err.response?.data?.error || err.message || 'Failed to load countries');
          setCountries([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return {
    countries,
    loading,
    error,
    reload: loadCountries,
  };
};

export default useCountries;
